import { render, staticRenderFns } from "./GestioneTeleconsulto.vue?vue&type=template&id=fcb7c6b4&"
import script from "./GestioneTeleconsulto.vue?vue&type=script&lang=js&"
export * from "./GestioneTeleconsulto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports